export default "__VITE_ASSET__678aa3a3__"